import { createActions, createReducer } from 'reduxsauce';

export const INITIAL_ITEM_STATE = {
  fetching: false,
  fetched: false,
  data: null, // { text } or { dataUrl } depending on call
  error: null,
};
export const INITIAL_STATE = {};

const { Types, Creators } = createActions(
  {
    generateText: ['id', 'params', 'resolve'],
    generateTextRequest: ['id'],
    generateTextSuccess: ['id', 'data'],
    generateTextFailure: ['id', 'error'],

    generateImage: ['id', 'params', 'resolve'],
    generateImageRequest: ['id'],
    generateImageSuccess: ['id', 'data'],
    generateImageFailure: ['id', 'error'],

    clearAiState: ['id'],
  },
  { prefix: 'cb/aiContent/' },
);

export { Types as types, Creators as actions };

const request = (state, { id }) => ({
  ...state,
  [id]: state[id]
    ? { ...state[id], fetching: true, error: null }
    : { ...INITIAL_ITEM_STATE, fetching: true },
});

const success = (state, { id, data }) => ({
  ...state,
  [id]: { ...INITIAL_ITEM_STATE, fetched: true, data },
});

const failure = (state, { id, error }) => ({
  ...state,
  [id]: { ...(state[id] || INITIAL_ITEM_STATE), fetching: false, error },
});

const clearAiState = (state, { id }) => ({
  ...state,
  [id]: INITIAL_ITEM_STATE,
});

export const HANDLERS = {
  [Types.GENERATE_TEXT_REQUEST]: request,
  [Types.GENERATE_TEXT_SUCCESS]: success,
  [Types.GENERATE_TEXT_FAILURE]: failure,

  [Types.GENERATE_IMAGE_REQUEST]: request,
  [Types.GENERATE_IMAGE_SUCCESS]: success,
  [Types.GENERATE_IMAGE_FAILURE]: failure,

  [Types.CLEAR_AI_STATE]: clearAiState,
};

export default createReducer(INITIAL_STATE, HANDLERS);
